import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ExperienceSection } from './components/ExperienceSection';
import { EducationSection } from './components/EducationSection';
import { ProjectsSection } from './components/ProjectsSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ExperienceSection data-id="element-5" />
        <EducationSection data-id="element-6" />
        <ProjectsSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}